import { useVerifyOtp } from "./modules/useVerifyOtp";

function VerifyOtpTemplate() {
  const { otp, setOtp, loading, error, handleVerify } = useVerifyOtp();

  return (
    <div>
      {loading && <h2>Loading...</h2>}
      {error && <div className="alert alert-danger">Invalid OTP</div>}
      <div className="row justify-content-center mt-5 mb-5">
        <div className="col-md-5">
          <div className="bs">
            <h1>Enter OTP</h1>
            <input
              type="text"
              className="form-control"
              placeholder="6-digit code"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            <button className="btn btn-primary mt-3" onClick={handleVerify}>
              Verify
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyOtpTemplate;
